import { render, staticRenderFns } from "./goodsAdd.vue?vue&type=template&id=d0a5c512&scoped=true"
import script from "./goodsAdd.vue?vue&type=script&lang=js"
export * from "./goodsAdd.vue?vue&type=script&lang=js"
import style0 from "./goodsAdd.vue?vue&type=style&index=0&id=d0a5c512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a5c512",
  null
  
)

export default component.exports